import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import styled, { css } from 'styled-components';
import { Stack, StackItem } from '../../../../Stack';
import { getComponentOverride } from '../../../../../system/mixins/getComponentOverride';
import { color } from '../../../../../system/mixins';
import { getPropsBlocker } from '../../../../../utils';

var contentBodyOptionsRootStyle = function contentBodyOptionsRootStyle(_ref) {
  var HeaderNavigationMenuContentBodyOptions = _ref.theme.componentOverrides.HeaderNavigationMenuContentBodyOptions;
  return HeaderNavigationMenuContentBodyOptions.Root.base;
};

var propertyList = {
  isActive: true
};

var contentBodyOptionsItemStyle = function contentBodyOptionsItemStyle(_ref2) {
  var isActive = _ref2.isActive,
      HeaderNavigationMenuContentBodyOptions = _ref2.theme.componentOverrides.HeaderNavigationMenuContentBodyOptions;
  var result = HeaderNavigationMenuContentBodyOptions.Item.base;

  if (isActive) {
    result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            ", ";\n            border-left-width: 2px;\n            border-left-style: solid;\n            padding-left: 14px;\n            border-left-color: ", ";\n            background-color: ", ";\n            color: ", ";\n        "])), result, color('primary.main'), color('primary.lightest'), color('neutral.06'));
  }

  return result;
};

var contentBodyOptionsCategoryStyle = function contentBodyOptionsCategoryStyle(_ref3) {
  var HeaderNavigationMenuContentBodyOptions = _ref3.theme.componentOverrides.HeaderNavigationMenuContentBodyOptions;
  return HeaderNavigationMenuContentBodyOptions.Category.base;
};

export var HeaderNavigationMenuContentBodyOptionsItem = styled(StackItem).withConfig(getPropsBlocker(propertyList, false))(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    box-sizing: border-box;\n\n    ", ";\n"])), contentBodyOptionsItemStyle);
export var HeaderNavigationMenuContentBodyOptionsRoot = styled(Stack).withConfig(getPropsBlocker(propertyList, false))(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n    ", ";\n"])), contentBodyOptionsRootStyle, getComponentOverride('HeaderNavigationMenuContentBodyOptions'));
export var HeaderNavigationMenuContentBodyOptionsCategory = styled(StackItem).withConfig(getPropsBlocker(propertyList, false))(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    cursor: default;\n    text-transform: uppercase;\n\n    ", "\n"])), contentBodyOptionsCategoryStyle);